import {useEffect, useState} from 'react'
import SearchList from '../../../sharedComponent/SearchList/SearchList'
import {AGENTLEADERLISTCONFIGS} from './AgentLeaderUtils'
import AddAgentLeader from '../AddAgentLeader'
import {
  DELETE_AGENT_LEADER,
  GET_AGENT_LEADER_LIST,
  UPDATE_AGENT_LEADER,
} from '../../../../utils/GraphQLAPI'
import {useLazyQuery, useMutation} from '@apollo/client'
import {GLOBAL_CONSTANTS} from '../../../../utils/GlobalConstants'
import EditAgentLeader from '../EditAgentLeader'
import {alert, areYouSurePrompt} from '../../../../utils/helper'
import Breadcrumbs from '../../../sharedComponent/Breadcrumbs/Breadcrumbs'
import {useParams} from 'react-router-dom'

type AgentLeaderListType = {
  showBreadCrumbs: boolean
}

const AgentLeaderList = ({showBreadCrumbs = true}: AgentLeaderListType) => {
  const getUrlParams = useParams()
  const [payload, setPayload] = useState<any>({
    page: 1,
    perPage: 10,
    salesChannelId: '',
  })
  const [agentLeaderList, setAgentLeaderList] = useState<any>([])
  const [getAgentLeaderList, {loading}] = useLazyQuery(GET_AGENT_LEADER_LIST, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    variables: payload,
    onCompleted: (res) => setAgentLeaderList(res.getAgentLeaderList),
  })

  useEffect(() => {
    if (getUrlParams.adminUser === 'systemadmin') {
      setPayload((prev: any) => ({
        ...prev,
        salesChannelId: Boolean(localStorage.getItem('salesEditId'))
          ? localStorage.getItem('salesEditId')
          : '',
      }))
    }
  }, [getUrlParams])

  useEffect(() => {
    getAgentLeaderList()
  }, [payload])

  //Edit Agent
  const [showEditModal, setShowEditModal] = useState(false)
  const [editAgentLeaderValues, setEditAgentLeaderValues] = useState({
    leaderName: null,
    leaderCode: null,
    leaderStatus: false,
    leaderId: null,
  })
  const handleEditAgentModalClose = () => {
    setShowEditModal(false)
    getAgentLeaderList({
      variables: payload,
    })
  }
  const [updateAgentLeader] = useMutation(UPDATE_AGENT_LEADER, {
    onCompleted: () => {
      alert('Agent Leader updated successfully', 'success')
      getAgentLeaderList({
        variables: payload,
      })
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
  })
  //deleteAgentLeader
  const [deleteAgentLeader] = useMutation(DELETE_AGENT_LEADER, {
    onCompleted: () => {
      alert('Agent Leader deleted successfully', 'success')
      getAgentLeaderList()
    },
  })
  const salesId = localStorage.getItem('salesEditId')
  return (
    <>
      {showBreadCrumbs && (
        <Breadcrumbs title='Agent Leader List' subTitle='Home - Agent Leader List' />
      )}

      <SearchList
        idFieldName='id'
        listConfigs={AGENTLEADERLISTCONFIGS}
        paginatedCount={agentLeaderList?.agentLeaders}
        listCount={agentLeaderList?.totalCount}
        listLoading={loading}
        filterOptions={payload}
        setFilterOptions={setPayload}
        apiData={agentLeaderList?.agentLeaders}
        toolbar={
          <AddAgentLeader
            salesAgentId={Boolean(salesId) ? salesId : ''}
            getAgentLeaderList={getAgentLeaderList}
          />
        }
        isActiveApiFieldName='leaderStatus'
        dropdownMenuItems={[
          {
            name: 'Edit',
            callBack: (id: string, name, apiDataValues) => {
              setEditAgentLeaderValues({
                leaderCode: apiDataValues.leaderCode,
                leaderId: apiDataValues.id,
                leaderName: apiDataValues.leaderName,
                leaderStatus: apiDataValues.leaderStatus,
              })
              setShowEditModal(true)
            },
          },
          {
            name: 'ACTIVATION',
            callBack: (id: string, _, apiDataValues) => {
              areYouSurePrompt(
                'Are you sure?',
                () =>
                  updateAgentLeader({
                    variables: {
                      updateAgentLeaderInputs: {
                        leaderId: apiDataValues.id,
                        leaderStatus: !apiDataValues['leaderStatus'],
                      },
                    },
                  }),
                () => {},
                'Yes',
                'No'
              )
            },
          },
          {
            name: 'Delete',
            callBack: (id: string) => {
              areYouSurePrompt(
                'Are you sure?',
                () =>
                  deleteAgentLeader({
                    variables: {
                      agentLeaderId: id,
                    },
                  }),
                () => {},
                'Yes, delete!',
                'No'
              )
            },
            textColor: 'text-danger',
          },
        ]}
      />
      {showEditModal && (
        <EditAgentLeader
          editAgentLeaderValues={editAgentLeaderValues}
          setShowEditModal={setShowEditModal}
          handleModalClose={() => handleEditAgentModalClose()}
        />
      )}
    </>
  )
}
export default AgentLeaderList
